
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/omnistar-alternative",
      function () {
        return require("private-next-pages/omnistar-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/omnistar-alternative"])
      });
    }
  